import type { BizCategoryState } from 'reactApp/modules/bizCategories/bizCategories.types';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getBizCategoriesState = (state: RootState): BizCategoryState => state.bizCategories;

export const getBizCategoriesList = createSelector(getBizCategoriesState, (state) => state.categories);
export const getBizCurrentCategory = createSelector(getBizCategoriesState, (state) => state.currentCategory);
